import {
	constantRoutes
} from '@/router'
// import router, { resetRouter, asyncRoutes } from '@/router'

import {
	findRouteMapping,
	buildTree
} from '@/api/user'
import Layout from '@/layout'

export const loadView = (view) => {
	return (resolve) => require([`@/views/${view}.vue`], resolve)
}
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
	if (route.meta && route.meta.roles) {
		return roles.some(role => route.meta.roles.includes(role))
	} else {
		return true
	}
}

function filterAsyncRouter(asyncRouterMap, roles) {
	// 核心修复1：先校验asyncRouterMap是否为数组，非数组直接返回空数组
	if (!Array.isArray(asyncRouterMap)) {
		console.warn('filterAsyncRouter入参错误：asyncRouterMap不是数组', asyncRouterMap);
		return [];
	}
	// 遍历后台传来的路由字符串，转换为组件对象
	let indexs = null
	const accessedRouters = asyncRouterMap.filter((route, index) => {
		if (route.component) {
			if (route.component === 'Layout' || route.component === Layout) {
				if (index == 0 && route.children) {
					route.path = '/'
					route.redirect = route.children[0].path
				}
				route.component = Layout
			} else {
				route.component = loadView(route.component)
			}
		}
		if (route.children && route.children.length) {
			route.children = filterAsyncRouter(route.children, roles)
		}

		if (!route.path) {
			indexs = index
		}
		return true
	})
	if (indexs) {
		accessedRouters.splice(indexs, 1)
	}

	return accessedRouters
}
/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
	const res = []
	routes.forEach(route => {
		const tmp = {
			...route
		}
		if (hasPermission(roles, tmp)) {
			if (tmp.children) {
				tmp.children = filterAsyncRoutes(tmp.children, roles)
			}
			res.push(tmp)
		}
	})
	return res
}

const state = {
	paths: [],
	routes: [],
	addRoutes: []
}

// 防止在短时间内重复 dispatch 导致重复请求接口（例如路由守卫多次触发）
let generatingRoutesPromise = null

const mutations = {
	SET_ROUTES: (state, routes) => {
		// state.paths = paths
		state.addRoutes = routes
		state.routes = constantRoutes.concat(routes)
	},
	RESET_ROUTES: (state) => {
		state.paths = []
		state.addRoutes = []
		state.routes = []
	},
	SET_PATHS(state, paths) {

		state.paths = filterAsyncRouter(paths, this.getters.roles)
		console.log('9999', paths)
	}
}

function unique(arr) {
	return Array.from(new Set(arr))
}
const actions = {
	generateRoutes({ commit, state, rootGetters }) {
		// 已经生成过路由：直接返回，避免重复请求
		if (state.addRoutes && state.addRoutes.length > 0) {
			return Promise.resolve(state.addRoutes)
		}

		// 正在请求中：复用同一个 Promise，避免并发重复请求
		if (generatingRoutesPromise) {
			return generatingRoutesPromise
		}

		generatingRoutesPromise = findRouteMapping()
			.then(response => {
				if (response.code !== 200) {
					throw response
				}

				// 后端排序字段处理
				response.data.sort((x, y) => (x.sortno > y.sortno ? 1 : -1))

				// 将数据转成树形图
				const a = buildTree({
					arrayList: response.data,
					pidStr: 'menuparentid',
					idStr: 'menuid'
				})

				// 获取我需要的路由表数据
				const asyncRouterMap = a[0].children || a[1].children
				const accessedRoutes = filterAsyncRouter(asyncRouterMap, rootGetters.roles)

				commit('SET_ROUTES', accessedRoutes)
				return accessedRoutes
			})
			.finally(() => {
				generatingRoutesPromise = null
			})

		return generatingRoutesPromise
	},
	resetRoutes({ commit }) {
		generatingRoutesPromise = null
		commit('RESET_ROUTES')
		return Promise.resolve()
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}